import React, {Component} from 'react';
import styled from 'styled-components';
import {Taggedem, Aspan, Tag, SentiTag, AspanSenti} from '../styles/text_styles.js';
import {NoExt} from '../styles/app_styles.js';

// CSS
import stylesSnippext from '../styles/snippext.module.css';

//sample data
import { jobJSONLarge } from '../jobJSONLarge.js';

class TextBody extends Component {
  constructor(props){
    super(props)
    this.state = {

    }

    // this.showExtraction = this.showExtraction.bind(this);
    // this.endShowExtraction = this.endShowExtraction.bind(this);
  }

  componentDidMount(){

  }

  createExtractionTypes(data, extractions, colorJSON){
    var extractionTypes = []
    var pairNumberTmp = 0
    var colorNdx = 0
    extractions.forEach(function(extraction){
      //if ext has 'aspect' & 'opinion': both get the same pairNumber & start ends are saved
      Array.from(["aspect", "opinion"]).forEach(function(ext_type){
        if(extraction[ext_type]){
          for(var key in extraction[ext_type]["positions"]){
            var position = extraction[ext_type]["positions"][key]
            extractionTypes.push({"type": ext_type, "start": position["begin"], "end": position["end"], "extractionNumber": pairNumberTmp, "sentiment": extraction["sentiment"], "value": key, "color_code": colorJSON[extraction["sentiment"]]})
          }
        }
      })
      pairNumberTmp = pairNumberTmp + 1
      pairNumberTmp += data.text.length
      colorNdx += 1
    })
    extractionTypes.sort(function(a, b){
      if(a.start > b.start){
        return 1
      }
      else {
        return -1
      }
    })
    return extractionTypes
  }

  aspOpinionPair(data){

    var text = data.text
    var extractions = data.extractions
    var colorJSON = {"positive": "#0d47a1", "neutral": "#0d47a1", "negative": "#0d47a1"}
    var extractionTypes = this.createExtractionTypes(data, extractions, colorJSON)

    let classes = {
      arrow: {
        color: "red",
      },
      tooltip: {
        backgroundColor: "red",
      }
    }
    var spans = []
    var previous = 0

    extractionTypes.forEach(function(extraction, i){

      var start = extraction.start
      var end = extraction.end
      let style_props = {code: extraction.color_code, type: extraction.type}
      let extraction_edit = "   " + extraction.type + "   "
      spans.push(
        <Aspan key= { previous } styled={style_props}>{ text.slice(previous, start) }</Aspan>
      )
      spans.push(
        <Tag styled={style_props} key = { "ao-" + extraction.start} >
            <Taggedem styled={style_props} key = { i + "start"+ extraction.start}>
            { text.slice(start, end) }
            </Taggedem>
            {extraction_edit.toUpperCase()}
        </Tag>
      )
      previous = end
      })
      spans.push(<span key={ "ao-" + previous }>{ text.slice(previous) }</span>)
        return spans
    }

  //change to have both words stay fully highlighted in green.
  //No hover function
  sentimentText(data){
    var text = data.text
    var extractions = data.extractions
    var colorJSON = {"positive": "#1b5e20", "neutral": "gray", "negative": "#f44336"}
    var extractionTypes = this.createExtractionTypes(data, extractions, colorJSON)

    // ===== Only highlighted the opinion, aspect class commented out.
    var spans = []
    var previous = 0
    extractionTypes.forEach(function(extraction, i){
      var start = extraction.start
      var end = extraction.end

      let style_props = {color_tag: extraction.color_code}
      let sentiment = extraction.sentiment.toUpperCase()

      let extraction_edit = "   " + sentiment

      spans.push(<Aspan key={ i }>{ text.slice(previous, start) }</Aspan>)

      if(extraction.type === "opinion"){
      spans.push(
        <SentiTag styled={style_props} key={ "sentiment-" + start }>
          <Taggedem > { text.slice(start, end) } </Taggedem>
          {sentiment}
        </SentiTag>
        )
        previous = end
      }
    })
    spans.push(<span key={"sentiment-" + previous}>{ text.slice(previous) }</span>)

    return spans
    }

    render(){
    // === content generating conditional based on step
    let spans = [];
    let data = this.props.data
    let step = this.props.step
    switch(step) {
      case 1:
      spans = this.aspOpinionPair(data)
        return spans

      case 3:
      spans = this.sentimentText(data)
        return spans

      default:
        spans.push(<NoExt> No Extractions Found </NoExt>)
        return spans
    }

      return (
          {spans}
        )
      }

  }

export default TextBody;
